import * as React from 'react';
import { toast } from 'react-toastify';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import { createOrUpdateSubject, subjectBySlugQuery } from '../../../queries/subjects';
import {
  CreateOrUpdateSubject,
  CreateOrUpdateSubjectVariables
} from '../../../queries/__generated__/CreateOrUpdateSubject';
import ErrorMessages from '../../ErrorMessages';
import { Input, Textarea } from '../../forms';
import { Button, Card } from '../../ui';
import { ErrorMessagesArray } from '../tracker/types';
import { Subject } from './types';
import { selectedNotebookQuery } from '../../../queries/notebooks';

interface SubjectInfo {
  subject: Subject;
  disabled?: boolean;
  userCanAdmin: boolean;
}

const SubjectInfo: React.FC<SubjectInfo> = ({ subject, userCanAdmin }) => {
  const { notebook, reloadNotebook } = React.useContext(NotebookContext);
  const [name, setName] = React.useState(subject.name || '');
  const [description, setDescription] = React.useState(subject.description || '');
  const [errors, setErrors] = React.useState<ErrorMessagesArray>([]);

  async function saveSubject() {
    subject.name = name;
    subject.description = description;

    const res = await client.mutate<CreateOrUpdateSubject, CreateOrUpdateSubjectVariables>({
      mutation: createOrUpdateSubject,
      variables: {
        input: {
          notebookId: notebook.id,
          id: subject.id,
          name: subject.name,
          description: subject.description
        }
      }
    });

    if (res.data!.createOrUpdateSubject.errors) {
      setErrors(res.data!.createOrUpdateSubject.errors);
      return;
    }
    if (errors.length) {
      setErrors([]);
    }

    reloadNotebook();
    toast('Settings saved!', { type: 'success' });
  }

  return (
    <Card className="pa4 mb2">
      <ErrorMessages errors={errors} />

      <Input
        label="Subject Name"
        value={name}
        onChange={e => setName(e.target.value)}
        className="mb3"
        data-testid="name-input"
        disabled={!userCanAdmin}
      />

      <Textarea
        label="Description"
        value={description}
        onChange={e => setDescription(e.target.value)}
        className="mb3"
        data-testid="description-input"
        disabled={!userCanAdmin}
      />

      {userCanAdmin && (
        <Button onClick={saveSubject} data-testid="save-info-button">
          Save
        </Button>
      )}
    </Card>
  );
};

export default SubjectInfo;
